export const FILTER_CONDITION_PANEL_WIDTH = 712;
